const fields = [
  {
    key: 'startTime',
    label: 'global.object.startTime',
    header: 'startTime',
    filter: false,
    width: 30,
  },
  {
    key: 'stopTime',
    label: 'master.form.fleet.endTime',
    header: 'stopTime',
    filter: false,
    width: 30,
  },
  {
    key: 'geofenceStart',
    label: 'report.fields.startGeofence',
    header: 'startGeofence',
    filter: true,
    width: 30,
  },
  {
    key: 'geofenceStop',
    label: 'report.fields.stopGeofence',
    header: 'endGeofence',
    filter: true,
    width: 30,
  },
  {
    key: 'geofence',
    label: 'report.fields.passedGeofence',
    header: 'intersectGeofences',
    filter: true,
    width: 30,
  },
  {
    key: 'driver',
    label: 'global.object.driver',
    header: 'driver',
    disabled: true,
    filter: false,
    width: 30,
  },
  {
    key: 'vehicle',
    label: 'global.object.licensePlate',
    header: 'licensePlate',
    disabled: true,
    filter: false,
    width: 30,
  },
  {
    key: 'tripMileage',
    label: 'report.fields.mileage',
    header: 'tripDistance',
    filter: false,
    width: 30,
  },
  {
    key: 'tripFuel',
    label: 'report.fields.actualFuel',
    header: 'tripFuel',
    filter: false,
    width: 30,
  },
  {
    key: 'fuelEfficiency',
    label: 'master.form.fleet.fuelEfficiency',
    header: 'fuelEfficiency',
    filter: false,
    width: 30,
  },
  {
    key: 'moveDuration',
    label: 'report.fields.moveTime',
    header: 'moveDuration',
    filter: false,
    width: 30,
  },
  {
    key: 'idleDuration',
    label: 'report.fields.idleTime',
    header: 'idleDuration',
    filter: false,
    width: 30,
  },
  {
    key: 'stopDuration',
    label: 'global.object.stopTime',
    header: 'stopDuration',
    filter: false,
    width: 30,
  },
  {
    key: 'tripDuration',
    label: 'liveView.modal.totalTripTime',
    header: 'tripDuration',
    filter: false,
    width: 30,
  },
  {
    key: 'speed',
    label: 'report.fields.averageSpeed',
    header: 'averageSpeed',
    filter: false,
    width: 30,
  },
]
export default fields
